import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import withAuth from "../../components/withAuth";
import qs from "querystringify";

// STATE AND STORE
// LIBS
import API from "../../api";
import Model from "../../models/bilets";
import validateForm from "../../lib/helpers/validateForm";
import {
  fioLitleTruncateFromObject,
  sumFormat
} from "../../lib/helpers/strings";
import {
  getDateFormat,
  getDateReturnDaysString
} from "../../lib/helpers/dates";
import * as CONSTANTS from "./constants";

// UI
import {
  HeaderPage,
  Table,
  Pagination,
  Input,
  Button,
  Row,
  Col,
  VirtualDiv,
  Dropdown
} from "../../ui";
import IconClockFilled from "../../ui/src/ui/components/icons/clockFilled";

const metaEmpty = {
  page: 0,
  pages: 0,
  count: 0,
  perPage: 0,
  fromRecord: 0,
  toRecord: 0
};

class BiletsListPage extends Component {
  state = {
    titleHeader: "Залоговые билеты",
    loading: true,
    bilets: {
      list: [],
      meta: metaEmpty
    },
    filials: {
      list: []
    },
    view: {
      list: [
        {
          id: "normal",
          title: "Действующие"
        },
        {
          type: "hr"
        },
        {
          id: "today",
          title: "Заканчивающиеся"
        },
        {
          id: "privilege",
          title: "Льготные"
        },
        {
          id: "overdue",
          title: "Просроченные"
        },
        {
          type: "hr"
        },
        {
          id: "material",
          title: "Материальная ведомость"
        },
        {
          type: "hr"
        },
        {
          id: "all",
          title: "Все"
        }
      ]
    },
    search: false,
    query: {
      page: 0,
      view: null
    },
    form: {
      number: {
        value: "",
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.number
      },
      iin: {
        value: "",
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.depositor.iin
      },
      filial: {
        value: "",
        isEdited: false,
        isError: false,
        errors: [],
        validate: Model.filial
      },
      view: {
        value: "",
        isEdited: false,
        isError: false,
        errors: []
      }
    },
    buttons: {
      filterDisabled: true
    }
  };

  async componentDidMount() {
    const { page, number, view, iin, filial } = qs.parse(
      window.location.search
    );
    const { form } = this.state;
    const searchParams = {};
    let search = false;

    if (page > 0) {
      searchParams.page = page;
    }

    if (number > 0) {
      search = true;
      form.number.value = number;
      searchParams.number = number;
    }

    if (iin > 0) {
      search = true;
      form.iin.value = iin;
      searchParams.iin = iin;
    }

    if (filial && filial.length) {
      search = true;
      form.filial.value = filial;
      searchParams.filial = filial;
    }

    if (view && CONSTANTS.VIEW_ALLOW.indexOf(view) !== -1) {
      if (search) {
        form.view.value = "all";
        searchParams.view = "all";
      } else {
        if (view === "normal") {
          form.view.value = "normal";
        } else {
          search = true;
          form.view.value = view;
          searchParams.view = view;
        }
      }
    } else {
      form.view.value = "normal";
    }

    this.props.history.push({
      pathname: "/bilets",
      search: qs.stringify(searchParams)
    });

    const { data, meta } = await API.bilets.getList(searchParams, {
      full: true
    });

    const { data: filials } = await API.filials.getList({}, { full: true });
    const filialsList = [
      {
        title: "Филиал не выбран",
        clear: true
      }
    ];
    (filials || []).forEach((item, i) => {
      if (i === 0) {
        filialsList.push({
          type: "hr"
        });
      }

      filialsList.push({
        id: item._id,
        title: item.name,
        onSelect: true,
        select: true
      });
    });

    this.setState({
      loading: false,
      bilets: {
        list: data || [],
        meta: meta || metaEmpty
      },
      filials: {
        list: filialsList
      },
      form,
      search,
      query: {
        page: page || 0
      },
      buttons: {
        filterDisabled: false
      }
    });
  }

  handleInput = e => {
    let value = e.target.value;
    let name = e.target.name;
    const { form } = this.state;

    if (name && form[name]) {
      if (form[name].isNumber) {
        value = String(value) || "";
      }

      this.setState(prevState => {
        return {
          form: {
            ...prevState.form,
            [name]: {
              ...prevState.form[name],
              value,
              isEdited: true,
              isError: false,
              errors: []
            }
          }
        };
      });
    }
  };

  handleSelectDropdown(item, name) {
    if (item && name) {
      let value = item.id;

      this.setState(
        prevState => {
          return {
            form: {
              ...prevState.form,
              [name]: {
                ...prevState.form[name],
                value,
                isEdited: true,
                isError: false,
                errors: []
              }
            }
          };
        },
        async () => {
          await this.handleSearchSubmit();
        }
      );
    }
  }

  handleSearchSubmit = async e => {
    if (e) {
      e.preventDefault();
    }

    const result = validateForm(this.state.form);

    this.setState({
      form: result.form,
      buttons: {
        filterDisabled: result.valid
      }
    });

    // Success
    if (result.valid) {
      this.setState({
        loading: true
      });

      const form = this.state.form;
      const number = form.number.value;
      const iin = form.iin.value;
      const filial = form.filial.value;
      const view = form.view.value;

      // Подготавливаем параметры
      let searchParams = {};

      // Нужен ли поиск?
      let isHaveSearch = false;

      // Есть изменения?
      if (number && parseInt(number, 10) > 0) {
        searchParams.number = parseInt(number, 10);
        isHaveSearch = true;
      }

      // Есть изменения?
      if (iin && parseInt(iin, 10) > 0) {
        searchParams.iin = parseInt(iin, 10);
        isHaveSearch = true;
      }

      // Есть изменения?
      if (filial && filial.length) {
        searchParams.filial = filial;
        isHaveSearch = true;
      }

      if (isHaveSearch) {
        if (view && CONSTANTS.VIEW_ALLOW.indexOf(view) !== -1) {
          searchParams.view = view;
        } else {
          searchParams.view = "all";
          form.view.value = "all";
        }
      } else {
        if (
          view &&
          CONSTANTS.VIEW_ALLOW.indexOf(view) !== -1 &&
          view !== "normal"
        ) {
          isHaveSearch = true;
          searchParams.view = view;
          form.view.value = view;
        }
      }

      // Есть изменения?
      if (isHaveSearch) {
        this.props.history.push({
          pathname: "/bilets",
          search: qs.stringify(searchParams)
        });

        const { data, meta } = await API.bilets.getList(searchParams, {
          full: true
        });

        this.setState({
          loading: false,
          bilets: {
            list: data || [],
            meta: meta || metaEmpty
          },
          search: true,
          form,
          query: {
            page: 0
          },
          buttons: {
            filterDisabled: false
          }
        });
      } else {
        this.handleSearchCancel();
      }
    }
  };

  handleSearchCancel = async e => {
    if (e) {
      e.preventDefault();
    }

    this.setState({
      loading: true,
      buttons: {
        filterDisabled: true
      }
    });

    this.props.history.push({
      pathname: "/bilets",
      search: ``
    });

    const { data, meta } = await API.bilets.getList({}, { full: true });

    this.setState(prevState => {
      return {
        loading: false,
        query: {
          page: 0
        },
        bilets: {
          list: data || [],
          meta: meta || metaEmpty
        },
        search: false,
        form: {
          ...prevState.form,
          number: {
            ...prevState.form.number,
            value: "",
            isEdited: true,
            isError: false,
            errors: []
          },
          iin: {
            ...prevState.form.iin,
            value: "",
            isEdited: true,
            isError: false,
            errors: []
          },
          filial: {
            ...prevState.form.filial,
            value: "",
            isEdited: true,
            isError: false,
            errors: []
          },
          view: {
            ...prevState.form.view,
            value: "normal",
            isEdited: true,
            isError: false,
            errors: []
          }
        },
        buttons: {
          filterDisabled: false
        }
      };
    });
  };

  onChangedPagination = async page => {
    const { number, iin, view } = qs.parse(window.location.search);
    const searchParams = { page };
    const queryParams = { page };

    if (number > 0) {
      queryParams.number = number;
      searchParams.number = number;
    }

    if (iin > 0) {
      queryParams.iin = iin;
      searchParams.iin = iin;
    }

    if (view && CONSTANTS.VIEW_ALLOW.indexOf(view) !== -1) {
      searchParams.view = view;
      queryParams.view = view;
    }

    this.props.history.push({
      pathname: "/bilets",
      search: qs.stringify(queryParams, true)
    });

    this.setState({
      loading: true,
      buttons: {
        filterDisabled: true
      }
    });

    const { data, meta } = await API.bilets.getList(
      { ...searchParams },
      { full: true }
    );
    this.setState({
      loading: false,
      bilets: {
        list: data || [],
        meta: meta || metaEmpty
      },
      query: {
        page
      },
      buttons: {
        filterDisabled: false
      }
    });
  };

  getListType = view => {
    switch (view) {
      case "all":
        return "Все";
      case "today":
        return "Заканчивающиеся";
      case "privilege":
        return "Льготные";
      case "overdue":
        return "Просроченные";
      case "material":
        return "Материальная ведомость";
      default:
        return "Действующие";
    }
  };

  getListTypeStyle = view => {
    switch (view) {
      case "privilege":
        return "warning";
      case "overdue":
        return "error";
      default:
        return null;
    }
  };

  getTableColumns = () => {
    return [
      {
        title: "",
        className: "id",
        render: ({ i }) => this.state.bilets.meta.fromRecord + i
      },
      {
        title: "№",
        suffix: "з/б",
        text: "right",
        render: ({ item }) => {
          return (
            <Link to={`/bilets/${item._id}`}>
              {sumFormat(parseInt(item.bilet_number, 10))}
            </Link>
          );
        }
      },
      {
        title: "Филиал",
        render: ({ item }) => {
          return (
            <Link to={`/filials/${item.filial_id._id}`}>
              {item.filial_id.name}
            </Link>
          );
        }
      },
      {
        title: "Сумма",
        suffix: "выдачи",
        text: "right",
        render: ({ item }) => sumFormat(item.sum_give)
      },
      {
        title: "%",
        render: ({ item }) => sumFormat(item.percent)
      },
      {
        title: "Сумма",
        suffix: "возврата",
        text: "right",
        render: ({ item }) => sumFormat(item.sum_return)
      },
      {
        title: "Залогодатель",
        render: ({ item }) => {
          return (
            <Link to={`/depositors/${item.depositor_id._id}`}>
              {fioLitleTruncateFromObject(item.depositor_id)}
            </Link>
          );
        }
      },
      {
        title: "Ответсвенный",
        render: ({ item }) => {
          return (
            <Link to={`/users/${item.user_id._id}`}>
              {fioLitleTruncateFromObject(item.user_id)}
            </Link>
          );
        }
      },
      {
        title: "Дата",
        suffix: "принятия",
        render: ({ item }) => getDateFormat(item.date_operation)
      },
      {
        title: "Дата",
        suffix: "возврата",
        render: ({ item }) => getDateFormat(item.date_return)
      },
      {
        title: "Возврат",
        render: ({ item }) => {
          const returnDateAndStyle = getDateReturnDaysString(item.date_return);

          return (
            <VirtualDiv>
              <IconClockFilled
                className={`icon-td icon-${returnDateAndStyle.style}`}
              />
              {returnDateAndStyle.string}
            </VirtualDiv>
          );
        }
      }
    ];
  };

  render() {
    const { bilets } = this.state;

    return (
      <div className="short">
        <Helmet>
          <title>{this.state.titleHeader}</title>
        </Helmet>

        <HeaderPage
          preBeforeTitle={this.getListType(this.state.form.view.value)}
          preBeforeTitleStyle={this.getListTypeStyle(
            this.state.form.view.value
          )}
          title={this.state.titleHeader}
          count={bilets.meta.count}
        />

        <form className="form" onSubmit={this.handleSearchSubmit}>
          <Row align="center">
            <Col padding="no-top-bottom">
              <Input
                label="№ з/б:"
                placeholder="Поиск по № з/б..."
                type="integer"
                name="number"
                value={this.state.form.number.value}
                errors={this.state.form.number.errors}
                handleChange={this.handleInput}
                size="s"
              />
            </Col>
            <Col padding="no-top-bottom-left">
              <Input
                label="ИИН залогодателя:"
                placeholder="Поиск по ИИН залогодателя"
                type="integer"
                name="iin"
                value={this.state.form.iin.value}
                errors={this.state.form.iin.errors}
                handleChange={this.handleInput}
                size="s"
              />
            </Col>
            <Col padding="no-top-bottom-left">
              <Dropdown
                label="Филиал:"
                name="filial"
                block={true}
                required={false}
                size="s"
                type="select"
                title="Выберите филиал"
                errors={this.state.form.filial.errors}
                list={this.state.filials.list}
                selectedId={this.state.form.filial.value}
                onSelect={item => {
                  this.handleSelectDropdown(item, "filial");
                }}
              />
            </Col>
            <Col padding="no-top-bottom-left">
              <Dropdown
                label="Статус:"
                name="view"
                block={true}
                required={false}
                size="s"
                type="select"
                title="Выберите статус"
                errors={this.state.form.view.errors}
                list={this.state.view.list}
                selectedId={this.state.form.view.value}
                onSelect={item => {
                  this.handleSelectDropdown(item, "view");
                }}
              />
            </Col>
            <Col padding="no-top-bottom-left">
              <Button
                type="submit"
                theme="dark"
                outline={true}
                size="s"
                disabled={this.state.buttons.filterDisabled}
                style={{ marginTop: 12 }}
              >
                Фильтр
              </Button>
              {this.state.search ? (
                <Button
                  type="button"
                  theme="grey"
                  outline={true}
                  onClick={this.handleSearchCancel}
                  size="s"
                  disabled={this.state.buttons.filterDisabled}
                  style={{ marginTop: 12 }}
                >
                  Сбросить
                </Button>
              ) : null}
            </Col>
          </Row>
        </form>

        <Table
          columns={this.getTableColumns()}
          data={bilets.list}
          loading={this.state.loading}
        />

        <Pagination
          linkPages={"/bilets"}
          linkPagesQuery={false}
          count={bilets.meta.count}
          page={bilets.meta.page || this.state.query.page}
          pages={bilets.meta.pages}
          onClick={this.onChangedPagination}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({});

export default withAuth(connect(mapStateToProps)(BiletsListPage));
